export default {"src":"/_next/static/media/arrow-left.9da35aca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};